import clsx from 'clsx'
import React, { useEffect, useRef } from 'react'

import Bubble from 'components/common/bubble/Bubble'
import { Flex } from 'components/common/flex/Flex'
import { adjustTextSize } from 'utils'

import styles from './MainBanner.module.scss'
import MainBannerImage from '../../assets/images/mainBanner/questions-intercom.png'

const MainBanner = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const profileRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setTimeout(() => adjustTextSize(containerRef.current, textRef.current, 170), 50)

    // Adjust text size on window resize to maintain responsiveness
    window.addEventListener('resize', () => adjustTextSize(containerRef.current, textRef.current, 210))

    // Check if the user has scrolled to the section

    return () => {
      window.removeEventListener('resize', () => adjustTextSize(containerRef!.current, textRef!.current, 210))
    }
  })

  const title: string = 'Tools & Support'
  const text: string =
    'Transform your day with what you need when you need it.  FYI, these tools are not confined here but served to you when you need them to complete a task. (Tipping optional.)'

  return (
    <div
      ref={profileRef}
      style={{ background: 'linear-gradient(180deg, #193ABE 0%, #0B77D7 62.53%)' }}
      className="flex flex-col h-full items-center overflow-y-auto overflow-x-hidden"
    >
      <div className={clsx(styles.containerText)} ref={containerRef}>
        <div ref={textRef} className={styles.weirdHeader}>
          TOOLS & SUPPORT
        </div>
      </div>
      <Flex direction="row" justify="between" className={styles.contentWrapper}>
        <Flex direction="column" className={styles.titleTextContainer}>
          <p className={styles.title}>{title}</p>
          <p className={`${styles.text} max-w-[734px]`}>{text}</p>
          <Bubble color="#EBFF00" text="I'm feeling smarter already" className={styles.bubble} direction="down" />
        </Flex>
        <div className="lg2:!absolute relative lg2:!right-[98px] lg2:!top-3 right-0 top-0">
          <img src={MainBannerImage} alt="mainbanner" className="h-[222px]" />
          <Bubble className={styles.bubbleInverted} color="#EBFF00" text="Ask me everything" direction="down" />
        </div>
      </Flex>

      <div
        style={{ background: 'linear-gradient(180deg, #193ABE 0%, #0B77D7 62.53%)' }}
        className="flex-1 w-[150%] px-[25%] mt-56"
      >
        <svg width="100%" height="400" viewBox="0 0 100 100" preserveAspectRatio="none" className="-mt-[400px]">
          <path d="M0,100 Q50,0 100,100 Z" fill="#FFFFFF" />
        </svg>
      </div>
    </div>
  )
}

export default MainBanner
